export enum Brands {
  NutmegResidence = "NutmegResidence",
  NutmegGrove = "NutmegGrove",
}
